import { LoginResponse, QrPollResponse, UserDetails } from '@repo/types';
import { $api } from './base';

export const logoutApi = (refreshToken: string): Promise<void> => {
  return $api
    .post('/api/auth/logout', { refresh: refreshToken })
    .then(() => undefined);
};

export const loginPortal = (payload: string): Promise<LoginResponse> => {
  return $api
    .post('/api/auth/login', {
      detail: payload,
    })
    .then((response) => response.data);
};

export const loginAdmin = (payload: string): Promise<LoginResponse> => {
  return $api
    .post('/api/admin/login', {
      detail: payload,
    })
    .then((response) => response.data);
};

export const getUserDetails = (): Promise<UserDetails> => {
  return $api.get('/api/auth/user-detail').then((response) => response.data);
};

export const pollQrLogin = (qrToken: string): Promise<QrPollResponse> => {
  return $api
    .post('/api/auth/login/qr/poll', {
      qr_token: qrToken,
    })
    .then((response) => response.data);
};
